import { useEffect } from "react";
import Select from "./components/Select";
import useFieldState from "./hooks/useFieldState";
import useEsri from "./hooks/useEsri";
import useForm from "./hooks/useForm";
import { GIS_PM_LAYER_NAME } from "./settings";

const QueryLayer = () => {
  const { register, resetZoneLaListField, onQueryLayerFieldChange } = useForm();
  const [fieldDataState] = useFieldState();
  const { esriLoader, removeAllDataLayers, removeLayer, resetMapZoom } =
    useEsri();

  useEffect(() => {
    if (!esriLoader || !onQueryLayerFieldChange) return;

    console.log(
      " %c ============== QueryLayer ===========",
      "background: #222; color: #bada55"
    );

    //rest app as each time query layer change.
    removeAllDataLayers();
    resetMapZoom();
    resetZoneLaListField();
    removeLayer(GIS_PM_LAYER_NAME);

    return () => {
      /* clean up */
    };
  }, [
    esriLoader,
    onQueryLayerFieldChange,
    removeAllDataLayers,
    removeLayer,
    resetMapZoom,
    resetZoneLaListField,
  ]);

  const { query_layers } = fieldDataState;

  return (
    <Select
      options={query_layers}
      label="Query Layer"
      name="query_layer"
      ref={register}
    />
  );
};

export default QueryLayer;
